/**
 * Placeholder image utilities
 * 
 * This file provides fallback images when real assets aren't available yet
 */

// Simple SVG encoding function
const encodeSVG = (svg: string): string => {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};

// Placeholder icons
export const placeholderIcons = {
  // Dashboard icons
  dashboardIcon1: encodeSVG(`
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="4" fill="#6610F2" fill-opacity="0.2"/>
      <path d="M17 9L13.5 5.5L9 10L6 7" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17 9L13.5 12.5L9 8L6 11" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M18 18H6" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `),
  
  dashboardIcon2: encodeSVG(`
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="4" fill="#6610F2" fill-opacity="0.2"/>
      <path d="M12 6V18" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17 10L12 6L7 10" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `),
  
  dashboardIcon3: encodeSVG(`
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="4" fill="#6610F2" fill-opacity="0.2"/>
      <path d="M18 10H6C5.44772 10 5 10.4477 5 11V17C5 17.5523 5.44772 18 6 18H18C18.5523 18 19 17.5523 19 17V11C19 10.4477 18.5523 10 18 10Z" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8 10V8C8 6.93913 8.42143 5.92172 9.17157 5.17157C9.92172 4.42143 10.9391 4 12 4C13.0609 4 14.0783 4.42143 14.8284 5.17157C15.5786 5.92172 16 6.93913 16 8V10" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="12" cy="14" r="1" fill="#6610F2"/>
    </svg>
  `),
  
  // Transaction icons
  transactionIcon1: encodeSVG(`
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="36" height="36" rx="8" fill="#FF5252" fill-opacity="0.1"/>
      <path d="M18 12V24" stroke="#FF5252" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M24 18H12" stroke="#FF5252" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `),
  
  transactionIcon2: encodeSVG(`
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="36" height="36" rx="8" fill="#00C853" fill-opacity="0.1"/>
      <path d="M18 12V24" stroke="#00C853" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M24 18H12" stroke="#00C853" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `),
  
  transactionIcon3: encodeSVG(`
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="36" height="36" rx="8" fill="#FFC107" fill-opacity="0.1"/>
      <path d="M26 20L18 12L10 20" stroke="#FFC107" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M18 12V26" stroke="#FFC107" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `),
  
  // Action icons
  actionDeposit: encodeSVG(`
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 17V3" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3 10L10 3L17 10" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `),
  
  actionWithdraw: encodeSVG(`
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 3V17" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17 10L10 17L3 10" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `),
  
  actionSwap: encodeSVG(`
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 17L17 3" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13 17H17V13" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7 3H3V7" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `),
  
  actionStake: encodeSVG(`
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 8L10 15L3 8" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17 3L10 10L3 3" stroke="#6610F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `),
  
  // Logo placeholder
  logo: encodeSVG(`
    <svg width="120" height="40" viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="8" fill="#6610F2"/>
      <path d="M9 20L15 26L31 10" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <text x="48" y="25" font-family="Arial" font-size="16" font-weight="bold" fill="white">PHANTOM</text>
    </svg>
  `),
  
  // Profile placeholder
  profile: encodeSVG(`
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#6610F2"/>
      <circle cx="16" cy="12" r="6" fill="white"/>
      <path d="M26 30C26 24.4772 21.5228 20 16 20C10.4772 20 6 24.4772 6 30" fill="white"/>
    </svg>
  `)
};

export default placeholderIcons; 